import angular from 'angular';

import Directives from './directives/';
import Filters from './filters';
import GlobalFactories from './globalFactories';

import DropzoneDirective from './dropzoneDirective';
import PDFDirective from './ngPDFDirective';

export default angular.module('app.common.angular', [
    Directives,
    Filters,
    GlobalFactories,
])

    .directive('dropzone', DropzoneDirective)
    .directive('ngPdf', PDFDirective)
    .run(($templateCache) => {

    })
    .name;



// WEBPACK FOOTER //
// ./src/app/common/angular/index.js